import React from 'react';

// ---------------------------------------------------------------------------
// Error Modal
// ---------------------------------------------------------------------------

export const ErrorModal = ({ isOpen, errors, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div
        className="modal-container modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 500, padding: '2rem' }}
      >
        <div className="modal-body">
          <h2 className="heading h3" style={{ marginBottom: '1rem' }}>
            There was a problem submitting your quote
          </h2>

          {errors && errors.length > 0 ? (
            <ul style={{ marginBottom: '1.5rem', paddingLeft: '0', listStyle: 'none', lineHeight: '1.5rem' }}>
              {errors.map((err, i) => (
                <li key={i} style={{ marginBottom: '0.5rem', color: '#c0392b' }}>
                  {err}
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ marginBottom: '1.5rem' }}>
              An unexpected error occurred. Please refresh the page and try again.
            </p>
          )}

          <button className="button button--primary" onClick={onClose} style={{ display: 'block', margin: '0 auto' }}>
            Close
          </button>
        </div>
        <span className="modal-close" onClick={onClose}>Close</span>
      </div>
    </div>
  );
};